<template>
  <div>
    <validation-observer ref="hardwareForm">
      <ValidationProvider rules="" vid="hardware">
        <b-form-radio-group
            v-model="CHECKOUT_DATA.has_hardware"
            stacked
        >
          <b-form-radio value="0">
            Ja
          </b-form-radio>
        </b-form-radio-group>
      </ValidationProvider>

      <div v-if="CHECKOUT_DATA.has_hardware == '0'" class="mb-2 mt-1">
        <div v-for="serviceOption in SERVICE.serviceOptions" :key="serviceOption.id">
          <div v-if="serviceOption.description == 'Hardware'">
            <validation-provider
                #default="{ errors }"
                name="Hardware"
                vid="hardware"
                rules="required"
            >
              <b-form-group label="Hardware" label-for="custom-hardware-option" class="required">
                <b-form-radio-group
                    v-model="CHECKOUT_DATA.hardwareOptions"
                >
                  <div v-for="(serviceOptionItem, key) in serviceOption.children" :key="serviceOptionItem.id">
                    <div v-if="serviceOptionItem.children" :class="key > 0 ? 'mt-2' : ''">
                      <h2 class="text-primary font-medium-1">{{ serviceOptionItem.description }}</h2>
                      <div v-for="serviceItem in serviceOptionItem.children" :key="serviceItem.id">
                        <b-form-radio name="hardware-options" :value="serviceItem"
                        >
                          {{ serviceItem.description }} - {{ formatPrice(serviceItem.price) }}
                          {{ serviceItem.item.baseQuantity == 1 ? 'einmalig' : 'monatlich' }}

                          <b-avatar
                              v-if="serviceOptionItem.descriptionDetailed"
                              class="mr-1 question-mark"
                              variant="secondary"
                              size="sm"
                              v-b-tooltip.hover.top="serviceItem.descriptionDetailed"
                              text="?"
                          >
                          </b-avatar>
                        </b-form-radio>
                      </div>
                    </div>
                    <div v-else>
                      <b-form-radio name="hardware-options" :value="serviceOptionItem"
                                    v-if="(
                                   serviceOptionItem.description.toLowerCase().indexOf('fritz!box') > -1 ||
                               serviceOptionItem.description.toLowerCase().indexOf('fritzbox') > -1 ||
                               serviceOptionItem.description.toLowerCase().indexOf('arris') > -1 ||
                               serviceOptionItem.description.toLowerCase().indexOf('lieferpauschale') > -1) && (
                                   serviceOptionItem.description.toLowerCase().indexOf('arrisbox refurbished') === -1
                               )
                               "
                      >
                        <service-option-item-text
                            :service-option-item="serviceOptionItem"
                            :product-dependencies="SERVICE.serviceOptionsDependencies"
                            :foot-node="serviceOptionItem.description == 'ArrisBox Refurbished' ? '7' : ''"
                        />

                        <b-avatar
                            v-if="serviceOptionItem.descriptionDetailed"
                            class="mr-1 question-mark"
                            variant="secondary"
                            size="sm"
                            v-b-tooltip.hover.top="serviceOptionItem.descriptionDetailed"
                            text="?"
                        >
                        </b-avatar>
                      </b-form-radio>
                    </div>
                  </div>
                </b-form-radio-group>
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </div>
        </div>
      </div>

      <ValidationProvider rules="" vid="active">
        <b-form-radio-group
            v-model="CHECKOUT_DATA.has_hardware"
            stacked
            vid="active"
            @change="unselectHardware()"
        >
          <b-form-radio value="1">
            Nein
          </b-form-radio>
        </b-form-radio-group>
      </ValidationProvider>

      <!--      <ValidationProvider rules="" vid="active">-->
      <!--        <b-form-checkbox v-model="CHECKOUT_DATA.separateBillingAddress.selected">-->
      <!--          Rechnungsanschrift-->
      <!--        </b-form-checkbox>-->
      <!--      </ValidationProvider>-->

      <div v-if="CHECKOUT_DATA.has_hardware == '1'" class="mt-1">
        <b-row>
          <b-col md="6">
            <b-form-group label="Router-Typ" label-for="custom-hardware-router-type" class="required">
              <validation-provider
                  #default="{ errors }"
                  name="Router Typ"
                  vid="router_type"
                  rules="required"
              >
                <b-form-input
                    id="custom-hardware-router-type"
                    v-model="CHECKOUT_DATA.custom_hardware.router_type"
                    placeholder="Bitte geben Sie Ihren Router-Typ an."
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="CWMP-Account" label-for="custom-hardware-cwmp-account" class="required">
              <validation-provider
                  #default="{ errors }"
                  name="CWMP-Account"
                  vid="cwmp_account"
                  rules="required"
              >
                <b-form-input
                    id="custom-hardware-cwmp-account"
                    v-model="CHECKOUT_DATA.custom_hardware.cwmp_account"
                    placeholder="Bitte geben Sie den CWMP-Account Ihres Routers an."
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group label="CMAC-Adresse" label-for="custom-hardware-c-mac-address" class="required">
              <validation-provider
                  #default="{ errors }"
                  name="C-MAC Adresse"
                  vid="c_mac_address"
                  :rules="{required: true,  max: { length: 17 }, min: {length: 17}}"
              >
                <b-form-input
                    id="custom-hardware-c-mac-address"
                    v-model="CHECKOUT_DATA.custom_hardware.c_mac_address"
                    placeholder="Bitte geben Sie die CMAC-Adresse Ihres Routers an."
                    v-mask="macAddressMask"
                />
                <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BFormCheckboxGroup,
  BFormCheckbox,
  BAvatar,
  VBTooltip, BFormRadio, BFormGroup
} from "bootstrap-vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {required, required_if, email, digits} from '@validations'
import ServiceOptionItemText from "@/components/ServiceOptionItemText";
import {max, regex} from '@validations'
export default {
  name: "HardwareSection",
  components: {
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BAvatar,
    ValidationProvider,
    ValidationObserver,
    ServiceOptionItemText,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      active: false,
      address: {},
      value: [],
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS,
      hardware: null,
      macAddressMask: 'NN:NN:NN:NN:NN:NN',
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.hardwareForm.validate()
    },
    hasDependency(serviceOptionItem) {
      return serviceOptionItem.dependencies.length > 0
    },
    getDependencies(serviceOptionItem) {
      if (serviceOptionItem.dependencies.length > 0) {
        let dependencyTexts = []

        for (let _serviceDependencyId of serviceOptionItem.dependencies) {
          let productDependency = this.getProductDependency(_serviceDependencyId)

          if (productDependency) {
            dependencyTexts.push(this.formatPrice(productDependency.price) + ' ' + productDependency.description);
          }
        }

        return dependencyTexts.join(" ,")
      }
    },
    getProductDependency(id) {
      for (let _productDependency of this.SERVICE.serviceOptionsDependencies) {
        if (_productDependency.id == id) {
          return _productDependency
        }
      }
    },
    unselectHardware() {
      this.CHECKOUT_DATA.hardwareOptions = []
    }
  }

}
</script>

<style lang="scss">
.custom-control-label {
  .question-mark {
    background: #000;
    width: 1rem;
    height: 1rem;
    position: relative;
    top: -2px;
  }
}

.tooltip-inner {
  white-space: pre-line;
  text-align: left;
  max-width: 240px;
}
</style>
